import { LoadBalancerChartsFallback } from '@/routes/load-balancer/tabs/overview/charts/fallback'
import { DiagramFallback } from '@/routes/load-balancer/tabs/overview/diagram/fallback'

export const OverviewTabFallback = () => {
  return (
    <div className="space-y-6 pb-25">
      <DiagramFallback />
      <LoadBalancerChartsFallback />
    </div>
  )
}
